import { SxProps, Theme } from '@mui/material';
import { PaperProps } from '@mui/material/Paper';

export const errorViewerDialogStyles: {
  dialog: PaperProps;
  title: SxProps<Theme>;
  box: SxProps<Theme>;
  content: SxProps<Theme>;
  contentSpan: SxProps<Theme>;
  action: SxProps<Theme>;
} = {
  dialog: {
    sx: {
      borderRadius: 3,
    },
  },
  title: {
    bgcolor: 'primary.main',
    color: 'common.white',
    py: 1.5,
    borderRadius: '8px 8px 0 0',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
  },
  content: {
    maxHeight: 400,
  },
  contentSpan: {
    fontWeight: 'bold',
    mr: 1,
  },
  action: {
    justifyContent: 'center',
  },
};
